import { Component, OnInit } from '@angular/core';
import { ZpDataService } from '../services/zp-data.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GetInfoAndPassService } from '../services/get-info-and-pass.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-sponsor-page',
    templateUrl: './sponsor-page.component.html',
    styleUrls: ['./sponsor-page.component.scss'],
    standalone: false
})
export class SponsorPageComponent implements OnInit {
  public user;
  public refCode;
  public logoUrl;
  public company: string;
  public subscription: Subscription;
  public statusAttachments;
  public professionalLogo;
  public firstName: string;
  public lastName: string;
  companyDetails: { userType?: string; professionalLicense?: string; funded?: boolean; hideSponsor?: boolean; directInvoice?: boolean; email?: string; company?: string; logo?: string; firstName?: string; lastName?: string; };
  displayPrePopulateText: boolean;

  constructor(private api: ZpDataService, private router: Router, private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService) {
    this.subscription = this.getInfoAndPassService.accessRightSection.subscribe((data) => {
      this.statusAttachments = data;
    });
  }

  ngOnInit() {
    this.api.getUser().then(async user => {
      this.user = user;
      if (this.user && this.user.prePopulateInitiated) {
        this.displayPrePopulateText = true
      } else {
        this.displayPrePopulateText = false
      }
      console.log('user', user);
      this.refCode = user.refCode;
      await this.api.setRefCode(this.refCode);
      this.logoUrl = await this.api.getLogoUrl(user.refCode);
      if (this.logoUrl && this.statusAttachments != 'empty') {
        this.professionalLogo = true;
      } else {
        // console.log('No logo.')
        this.professionalLogo = false;
      }
      this.companyDetails = await this.api.getRefCodeInfo();
      this.company = this.api.getRefCodeInfo() && this.api.getRefCodeInfo().company;
      this.firstName = this.api.getRefCodeInfo() && this.api.getRefCodeInfo().firstName;
      this.lastName = this.api.getRefCodeInfo() && this.api.getRefCodeInfo().lastName;
    });
  }

  finishSignup() {
    this.router.navigateByUrl('/dynamicedit/sponsor-about-me-edit/' + this.user.Id);
  }

}
